import * as React from 'react';
import * as styles from './modal.module.scss';
import Attachment from '../../../models/attachment';

interface Props {
  files: Attachment[];
}

/**
 * AttachedFiles
 * @function AttachedFiles - Component for list of attached files
 */
const AttachedFiles = ({ files }: Props) => {
  /**
   * @const renderFiles - Renders list of files
   */
  const renderFiles = () => {
    return files.map(file => {
      return (
        <a key={`file-${file.downloadUrl}`} href={file.downloadUrl} target="_blank">
          {file.fileName}
        </a>
      );
    });
  };

  return (
    <div className={styles.files}>
      <span>Attached Files</span>
      {renderFiles()}
    </div>
  );
};

export default AttachedFiles;
